import WorkWithMeSection from '#app/components/work-with-me.tsx';
import { type Route } from './+types/contact.ts'

export const meta: Route.MetaFunction = () => {
	// const searchQuery = new URLSearchParams(
	// 	location.search
	//   ).get("q");
    // return [{ title: `Search results for "${searchQuery}"` }];

	var title = "JaseOwns - Contact";
	var description = "If you are looking for a developer, don't hesitate to reach out!";
	return [
		{ title: title },
	  	{ name: "description", content: description},
	  	{ name: "keywords", content: "self taught,learning,jaseowns,jase,jason, contract work, developer, developer for hire"},
		{ property: "og:image", content: "https://jaseowns.com/images/creator_jase.jpg"},
		{ property: "og:image:alt", content: "JaseOwns Headshot Image"},
		{ property: "twitter:card", content: "summary"},
		{ property: "twitter:creator", content: "@jaseowns"},
		{ property: "twitter:site", content: "@jaseowns"},
		{ property: "og:title", content: title},
		{ property: "og:description", content: description},
	];
  };

export default function ContactRoute() {
	return (
		<main className="container mx-auto text-black dark:text-white">

			<WorkWithMeSection />

		</main>
	)
}



